class BlueRadioButton extends RadioButton {
    constructor(label: string, controller: Controller, oldContainer: JQuery, radioGroup: RadioGroup, mode: string) {
        super(oldContainer.attr("value"), label, controller, oldContainer, radioGroup, mode);
    }

    initHTML(oldElement, label) {
        var newHTML = '';

        newHTML += '<div class="radio_option">';
        newHTML += '    <div class="radio_option_circle">&nbsp;</div>';
        newHTML += '    <div class="radio_option_label">' + label + '</div>';
        newHTML += '</div>';

        this.container = $(newHTML);

        oldElement.replaceWith(this.container);
    }

    setEnabled(enabled: boolean) {
        // TODO: implement setEnabled() in all radioButtons
    }

    isEnabled():boolean {
        return !this.container.hasClass("disabled");
    }

    previewEnabled(enabled: boolean) {
        // TODO: implement previewEnabled() in all radioButtons
    }

    setSelected(selected: boolean) {
        this.container.toggleClass("selected", selected);
    }

    isSelected(): boolean {
        return this.container.hasClass("selected");
    }

    previewSelected(selected: boolean, timeRatioLeft: number) {
        if(this.container.hasClass("selected") && !selected) {
            this.container.addClass("feedforward_deselected");
        } else if(!(this.container.hasClass("selected")) && selected) {
            this.container.addClass("feedforward_selected");
        }
    }

    removePreviewSelected() {
        this.container.removeClass("feedforward_selected feedforward_deselected");
    }

    removePreviewEnabled() {
    }
}